import React from "react";
import cn from "classnames";
import { showTitleWithDots } from "../../../../../helpers";
import styles from "../ItemsBlock/ItemsBlock.module.scss";

interface MenuItem {
  title: string;
  url?: string;
  isInternalLink?: boolean;
  target?: string;
  menu?: MenuItem[];
  id: string | number;
}

interface ItemsProps {
  list: MenuItem[];
  handleLinkClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, url: string, target?: string, isInternalLink?: boolean) => void;
}

const Items: React.FC<ItemsProps> = ({ list, handleLinkClick }) => {
  return (
    <>
      {list.map(item => (
        <a
          key={item.id}
          itemProp="url"
          className={cn(styles.item)}
          href={item.url}
          target={item.target || "_self"}
          onClick={e => handleLinkClick(e, item.url!, item.target, item.isInternalLink)}
          onMouseEnter={e => showTitleWithDots(e, item.title, true)}
        >
          <span itemProp="name">{item.title}</span>
        </a>
      ))}
    </>
  );
};

export default Items;
